import React, { Component } from 'react'
import { TextInput, DatePicker, Select, Button, Colors, Checkbox } from 'advenio-components'
import { Form } from 'formsy-react' //eslint-disable-line
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import R, { isEmpty, isNil } from 'ramda'
import moment from 'moment'

import LoadingSpinner from '../LoadingSpinner'
import ProfileHeader from '../../Components/ProfileHeader'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import { Selectors as CountrySelector } from '../../Data/Redux/CountriesRedux'
import ErrorIsland from '../../Components/ErrorIsland'
import { compareFirstInSecondJSON, getCookie, userHasRole } from '../../utils/Utils'
import { BACK_OFFICE_CENTER_ROLES } from '../../Constants'

const InputContainer = styled.div`
  width: calc(100% - 32px);
  margin: 16px;
  @media (min-width: 1024px) {
    width: 250px;
  }
  @media (min-width: 1440px) {
    width: 270px;
  }
`
const ProfileContainer = styled.div`
  padding: 8px;
`

const ProfileSection = styled.div`
  display: flex;
  width:100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`
const ErrorRow = styled.div`
  display: flex;
  justify-content: center;
`

const DangerZone = styled.div`
  flex:1;
  justify-content: flex-start;
  display: flex;
  background: ${Colors.red100};
  flex-direction: column;
  color:${Colors.redText};
  padding: 16px;
  h3 {
    margin:0;
    margin-bottom: 16px;
  }
`
const DangerRow = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
  }
  span:first-of-type{
    font-weight: bold;
  }
`
const WarningZone = styled.div`
  flex:1;
  justify-content: flex-start;
  display: flex;
  background: ${Colors.yellow100};
  flex-direction: column;
  color:${Colors.yellowText};
  padding: 16px;
  h3 {
    margin:0;
    margin-bottom: 16px;
  }
`
const WarningRow = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
  }

`
class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      classrooms: [],
      studyPrograms: [],
      profile: {},
      selectedParentId: 0,
      parentOptions: [],
      littleSibling: false,
      prefixSymbol: '',
      sufixSymbol: '',
      disabled: false,
      bannerCaution: false,
    }
  }
  componentDidMount = () => {
    const { profile: { checkin }, profile, loading } = this.props
    const cloneClassrooms = R.clone(this.props.classrooms)
    const cloneStudyPrograms = R.clone(this.props.studyPrograms)

    let littleSibling = false

    if (profile.siblings.length > 0) {
        littleSibling = profile.siblings.map(sibling => profile.birth_date > sibling.birth_date)
    }
    const newParentOptions = [{id:0,label:'Selecciona un tutor',value:0}].concat(profile.parents.map((parent) => {
      const fullName = `${parent.first_name} ${parent.last_name_paternal}`
      const selectedParentId = parent.userable_id || parent.id

      return ({
            id: selectedParentId,
            label: fullName,
            value: selectedParentId,
          })
    }))


    if (profile.support_as_pct) {
      this.setState({ prefixSymbol: 'P', sufixSymbol: '%' })
    }

    const newClassrooms = cloneClassrooms.map(classroom => (
      {
        label: classroom.name,
        value: classroom.id,
        id: classroom.id,
      }
    ))

    const foundParent = profile.parents.find(parent => parent.id === profile.paying_parent_id || parent.userable_id === profile.paying_parent_id)
    let selectedParentId

    if (foundParent) {
      selectedParentId = foundParent.userable_id || foundParent.id
    } else if (profile.parents.length > 0) {
      selectedParentId = profile.parents[0].userable_id || profile.parents[0].id
    }

    const newStudyPrograms = cloneStudyPrograms.map(sp => (
      {
        label: sp.name,
        value: sp.id,
        id: sp.id,
      }
    ))
    if (checkin.is_virtual_center) {
      this.setState({ classrooms: newClassrooms, studyPrograms: newStudyPrograms, parentOptions: newParentOptions, selectedParentId,  littleSibling})
    } else {
      if (!loading) {
        this.setState({ classrooms: newClassrooms, studyPrograms: newStudyPrograms, parentOptions: newParentOptions, selectedParentId,  littleSibling})
      }
    }

    const { role } = JSON.parse(getCookie('advenio_user'))
    this.setState({
      disabled: role !== 'Back Office Admin' ? true : false
    })
  }

  componentWillMount () {
    this.setState({profile:this.props.profile})
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if(this.props.profile !== nextProps.profile) {
      let profile = nextProps.profile
      this.setState({profile})
    }
  }

  onSubmit = (data) => {
    const { profile } = this.state
    const dataWithDOBFormated = { ...data }
    if (data.birth_date.length > 0) {
      dataWithDOBFormated.birth_date = moment(data.birth_date).format('YYYY-MM-DD')
    }

    dataWithDOBFormated.classroom_id = Number(dataWithDOBFormated.classroom_id)
    dataWithDOBFormated.study_program_id = Number(dataWithDOBFormated.study_program_id)
    dataWithDOBFormated.support_as_pct = Boolean(dataWithDOBFormated.support_as_pct)

    const patchData = compareFirstInSecondJSON(dataWithDOBFormated, profile)
    this.props.updateStudent(this.props.activeStudentId, patchData, profile.updated_at)
  }

  handleChange = (model) => {
    const { support_as_pct } = model
    const { country, classrooms } = this.props
    let bannerCaution = false

    if (!support_as_pct) {
      this.setState({
        prefixSymbol:  country !== undefined ? country.currency_symbol : '$',
        sufixSymbol: country !== undefined ? country.currency_code : 'MXN' ,
      })
    } else {
      this.setState({
        prefixSymbol: 'P',
        sufixSymbol: '%',
      })
    }

    if(model.classroom_id !== undefined) {
      const {name} = classrooms.find(c=> c.id === Number(model.classroom_id))
      if(name === 'Advenio Externo') {
        bannerCaution = true
      }
    }

    this.setState({bannerCaution})
  }

  render() {
    const {
      country,
      error,
      isDisenrolled,
      loading,
      onDeleteStudent,
      teacher,
      isVirtualCenter,
      user,
    } = this.props
    const profile = this.state.profile
    const {parentOptions, selectedParentId, littleSibling, bannerCaution } = this.state
    return (
      <div>
        <ProfileContainer>
          <Form onSubmit={this.onSubmit} onChange={this.handleChange}>
            <ProfileHeader
              header="Perfil"
              submit
              disabled={teacher || Boolean(isDisenrolled)}
            />
            {error && <ErrorRow>
              <ErrorIsland error={error} />
            </ErrorRow>}
            {
              loading ? <LoadingSpinner containerHeight={120} size={25} /> : (
                <ProfileSection>
                  <InputContainer>
                    <TextInput
                      name="first_name"
                      label="Nombre"
                      required
                      value={profile.first_name}
                      disabled={teacher || Boolean(isDisenrolled)}
                    />
                  </InputContainer>
                  <InputContainer>
                    <TextInput
                      name="last_name_paternal"
                      label="Apellido Paterno"
                      required
                      value={profile.last_name_paternal}
                      disabled={teacher || Boolean(isDisenrolled)}
                    />
                  </InputContainer>
                  <InputContainer>
                    <TextInput
                      name="last_name_maternal"
                      label="Apellido Materno"
                      value={profile.last_name_maternal}
                      disabled={teacher || Boolean(isDisenrolled)}
                    />
                  </InputContainer>
                  <InputContainer>
                    <Checkbox
                      label="Usa Pañal"
                      name="uses_diapers"
                      invertedColors
                      large
                      hideEmptyHelpBlock
                      value={profile.uses_diapers}
                      disabled={teacher || Boolean(isDisenrolled)}
                    />
                  </InputContainer>
                  <InputContainer>
                    <DatePicker
                      name="birth_date"
                      value={profile.birth_date}
                      disabled={teacher || Boolean(isDisenrolled)}
                      label="Fecha de nacimiento"
                      required
                    />
                  </InputContainer>
                  <InputContainer>
                    <Checkbox
                      label="% Descuento"
                      name="support_as_pct"
                      invertedColors
                      large
                      hideEmptyHelpBlock
                      value={Boolean(profile.support_as_pct)}
                      disabled={this.state.disabled}
                    />
                  </InputContainer>
                  <InputContainer>
                    <TextInput
                      name="custom_tuition_fee"
                      value={profile.custom_tuition_fee}
                      label="Precio Variable / Desuento de Hermanos"
                      prefix={this.state.prefixSymbol == '' ? country !== undefined ? country.currency_symbol : '$' : this.state.prefixSymbol}
                      suffix={this.state.sufixSymbol == '' ? country !== undefined ? country.currency_code : 'MXN' : this.state.sufixSymbol}
                      disabled={this.state.disabled}
                    />
                  </InputContainer>
                  <InputContainer>
                      <Select
                        name="gender"
                        label="Género"
                        required
                        value={profile.gender}
                        options={[
                          {
                            id: 1,
                            value: 1,
                            label: 'Masculino',
                          },
                          {
                            id: 2,
                            value: 2,
                            label: 'Femenino',
                          }
                        ]}
                      />
                    </InputContainer>
                  {parentOptions.length > 0  &&  !isNil(user) && (<InputContainer>
                      <Select
                        name="paying_parent_id"
                        label="Facturar a"
                        required
                        value={profile.paying_parent_id}
                        options={parentOptions}
                        disabled={teacher || Boolean(isDisenrolled) || (userHasRole(user,BACK_OFFICE_CENTER_ROLES) && (!isNil(user.center_id) && user.center_id !== profile.center.id))}
                      />
                    </InputContainer>)
                }
                  {typeof profile.tax_info != "undefined" &&
                    <InputContainer>
                      <TextInput
                        name="tax_id"
                        value={profile.tax_info && profile.tax_info.tax_id}
                        label="CURP"
                      />
                    </InputContainer>
                  }
                </ProfileSection>
              )
            }
            {!profile.checkin.is_virtual_center && <h2 style={{ margin: '16px' }}>Sala</h2>}
            {!profile.checkin.is_virtual_center && loading && (
              <LoadingSpinner containerHeight={120} size={25} />
            )}
            <InputContainer>
                <Select
                  name="classroom_id"
                  label="Sala"
                  required
                  value={profile.classroom_id || 1}
                  fullWidth
                  options={this.state.classrooms}
                  disabled={teacher || Boolean(isDisenrolled || isVirtualCenter ) /*|| (profile.checkin.status === "Advenio" || profile.checkin.status === "Nurse's Room")*/}
                />
              </InputContainer>
              <InputContainer>
                <Select
                  name="study_program_id"
                  label="Programa"
                  required
                  value={profile.study_program_id || 1}
                  disabled={teacher || Boolean(isDisenrolled || isVirtualCenter )/* || (profile.checkin.status === "Advenio" || profile.checkin.status === "Nurse's Room")*/}
                  fullWidth
                  options={this.state.studyPrograms}
                />
              </InputContainer>
            {!profile.checkin.is_virtual_center && <ProfileSection>
                {/* // TODO: Descomentar cuando se tenga en la api */}
                <InputContainer>
                    <Checkbox
                      label="Servicio Híbrido"
                      name="service_hybrid"
                      invertedColors
                      large
                      hideEmptyHelpBlock
                      value={Boolean(profile.service_hybrid)}
                      disabled={(profile.status_id === 5)||Boolean(isDisenrolled)}
                    />
                  </InputContainer>
            </ProfileSection>}
          </Form>
        </ProfileContainer>
        {bannerCaution&&(
            <ProfileSection>
            <WarningZone>
                <h3>Precaución</h3>
                <WarningRow>
                  <div>
                    <span>Asegurarse sí el alumno usa un servicio híbrido.</span>
                    {/* <span>Este proceso puede ser revertido en la pantalla de inscripciones</span> */}
                  </div>
                </WarningRow>
              </WarningZone>
            </ProfileSection>
        )}
        <ProfileSection>
          {(!teacher && !isDisenrolled) && (<DangerZone>
            <h3>Zona de peligro</h3>
            <DangerRow>
              <div>
                <span>Dar de baja un estudiante</span>
                <span>Este proceso puede ser revertido en la pantalla de inscripciones</span>
              </div>
              <Button
                danger
                small
                onClick={onDeleteStudent}
                disabled={teacher || Boolean(isDisenrolled)}
              >
                Dar de baja
              </Button>
            </DangerRow>

          </DangerZone>)}
        </ProfileSection>
      </div>
    )
  }
}

Profile.propTypes = {
  profile: PropTypes.object.isRequired,
  activeStudentId: PropTypes.number.isRequired,
  updateStudent: PropTypes.func.isRequired,
  error: PropTypes.string,
  classrooms: PropTypes.array.isRequired,
  isDisenrolled: PropTypes.bool,
  onDeleteStudent: PropTypes.func,
}

Profile.defaultProps = {
  error: null,
  isDisenrolled: false,
  onDeleteStudent: () => null,
}

const mapStateToProps = state => ({
  activeStudentId: state.classrooms.activeStudentId,
  error: state.classrooms.get.error,
  classrooms: state.classrooms.get.results,
  loading: state.classrooms.get.fetching,
  country: CountrySelector.activeCountry(state),
})

const mapDispatchToProps = dispatch => ({
  updateStudent: (activeParentId, profile, timestamp) =>
    dispatch(ClassroomActions.updateStudentRequest(activeParentId, profile, timestamp)),
})


export default connect(mapStateToProps, mapDispatchToProps)(Profile)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Profile.jsx